import React, { useEffect } from 'react';
import styled from 'styled-components';
import { useQuery } from '~~utils/CommonUtils';
import { TABLET_WIDTH } from '~~elements/Const';

const StyledDiv = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: start;
  margin-bottom: 1rem;
  gap: 0.3rem;
  .season-team {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: start;
    justify-content: flex-start;
    &--header {
      &--name {
        font-size: 1.2rem;
      }
      &--change {
        color: #aaaaaa;
        display: flex;
        align-items: center;
        font-size: 0.8rem;

        select,
        option {
          color: #aaaaaa;
          &:hover,
          &:focus {
            display: inline-block;
          }
        }

        &-hint {
          font-size: 0.8rem;
        }
        select {
          display: none;
        }

        &:hover,
        &:focus {
          select {
            display: inline-block;
          }
        }
      }
    }
  }

  @media (max-width: ${TABLET_WIDTH}) {
    text-align: center;
    align-items: center;
    .season-team {
      align-items: center;
      margin: 0.3rem 0;
      &--header {
        &--name {
          font-size: 1rem;
        }
        &--change {
          font-size: 0.8rem;
        }
        &--change-hint {
          margin-left: 0;
        }
      }
    }
  }
`;

const TeamSeasonHeader = ({ seasons, seasonIndex, seasonTeamIndex, setSeasonIndex, setSeasonTeamIndex }) => {
  const query = useQuery();
  useEffect(() => {
    if (!seasons[seasonIndex] || !seasons[seasonIndex].teams[seasonTeamIndex]) {
      query.delete('tsindex');
      query.delete('tstindex');
      setSeasonIndex(0);
      setSeasonTeamIndex(0);
      return;
    }

    const tsindex = query.get('tsindex');
    let querySeasonIndex = parseInt(tsindex);
    if (!tsindex) {
      querySeasonIndex = seasonIndex;
    }

    const tstindex = query.get('tstindex');
    let querySeasonTeamIndex = parseInt(tstindex);
    if (!tstindex) {
      querySeasonTeamIndex = seasonTeamIndex;
    }

    if (querySeasonIndex === seasonIndex && querySeasonTeamIndex === seasonTeamIndex) {
      return;
    }

    if (Number.isNaN(querySeasonIndex) || querySeasonIndex < 0 || querySeasonIndex > seasons.length - 1) {
      return query.delete('tsindex');
    }
    setSeasonIndex(querySeasonIndex);

    if (
      Number.isNaN(querySeasonTeamIndex) ||
      querySeasonTeamIndex < 0 ||
      querySeasonTeamIndex > seasons[querySeasonIndex].teams.length - 1
    ) {
      return query.delete('tstindex');
    }
    setSeasonTeamIndex(querySeasonTeamIndex);
  }, [query, seasonIndex, seasonTeamIndex, seasons, setSeasonIndex, setSeasonTeamIndex]);

  const handleSeasonChange = (e) => {
    query.set({ tsindex: e.target.value });
  };

  const handleSeasonTeamChange = (e) => {
    query.set({ tstindex: e.target.value });
  };

  if (seasons.length === 0 || !seasons[seasonIndex]) {
    return <></>;
  }

  if (seasons[seasonIndex].teams.length === 0 || !seasons[seasonIndex].teams[seasonTeamIndex]) {
    return <></>;
  }

  return (
    <StyledDiv>
      <div className="season-team">
        <div className="season-team--header--name">
          <div>{seasons[seasonIndex].seasonName}</div>
        </div>
        {seasons.length > 1 && (
          <div className="season-team--header--change">
            <div className="season-team--header--change-hint">切換</div>
            <select value={seasonIndex} onChange={handleSeasonChange}>
              {seasons.map((season, index) => (
                <option key={index} value={index}>
                  {season.seasonName}
                </option>
              ))}
            </select>
          </div>
        )}
      </div>
      <div className="season-team">
        <div className="season-team--header--name">
          <div>{`- ${seasons[seasonIndex].teams[seasonTeamIndex].name}`}</div>
        </div>
        {seasons[seasonIndex].teams.length > 1 && (
          <label className="season-team--header--change" tabIndex="-1">
            <div className="season-team--header--change-hint">切換</div>
            <select value={seasonTeamIndex} onChange={handleSeasonTeamChange}>
              {seasons[seasonIndex].teams.map((team, index) => (
                <option key={index} value={index}>
                  {team.name}
                </option>
              ))}
            </select>
          </label>
        )}
      </div>
    </StyledDiv>
  );
};

export default TeamSeasonHeader;
